const abortControllersByProcessId = new Map<string, AbortController>();
const cancelledProcessIds = new Set<string>();

export function registerDownloadAbort(processId: string): AbortController {
  const abortController = new AbortController();
  abortControllersByProcessId.set(processId, abortController);
  cancelledProcessIds.delete(processId);
  return abortController;
}

export function isDownloadCancelled(processId: string): boolean {
  return cancelledProcessIds.has(processId);
}

export function cancelDownload(processId: string): void {
  cancelledProcessIds.add(processId);
  abortControllersByProcessId.get(processId)?.abort();
  abortControllersByProcessId.delete(processId);
}

export function cancelAllDownloads(processIds: string[]): void {
  processIds.forEach((processId) => cancelledProcessIds.add(processId));
  abortControllersByProcessId.forEach((abortController) => abortController.abort());
  abortControllersByProcessId.clear();
}

export function unregisterDownloadAbort(processId: string): void {
  abortControllersByProcessId.delete(processId);
  cancelledProcessIds.delete(processId);
}

export function resetDownloadCancellationForTests(): void {
  abortControllersByProcessId.forEach((abortController) => abortController.abort());
  abortControllersByProcessId.clear();
  cancelledProcessIds.clear();
}
